import { useModal } from '@openeducation/oe-it-components';
import {
  useEnvironmentContext,
  useLoginContext,
} from '@openeducation/oe-it-providers';
import React from 'react';

import { useRedirectTo } from '../../hooks/use-redirect-to';
import { KeepAliveService } from '../../services/keep-alive.service';
import { ConnectionIssueModal } from '../connection-issue-modal/connection-issue-modal';

const INTERVAL_TIME = 60000;
const MAX_FAIL_COUNT = 3;

export const KeepAlive = () => {
  const { openModal, closeModal } = useModal();
  const { environment } = useEnvironmentContext();
  const { logout, personId, loginUuid } = useLoginContext();
  const { redirectTo } = useRedirectTo();

  const [keepAliveFailCount, setKeepAliveFailCount] = React.useState<number>(0);

  const handleReconnectPress = React.useCallback(() => {
    setKeepAliveFailCount(0);
    closeModal();
    logout?.(redirectTo);
  }, [closeModal, logout, redirectTo]);

  React.useEffect(() => {
    if (keepAliveFailCount === MAX_FAIL_COUNT) {
      openModal(
        <ConnectionIssueModal onReconnectPress={handleReconnectPress} />,
        { showCloseButton: false }
      );
    }
  }, [keepAliveFailCount, openModal, handleReconnectPress]);

  React.useEffect(() => {
    function callKeepAlive() {
      KeepAliveService.postAlive(environment, personId, loginUuid)
        .then(() => {
          setKeepAliveFailCount(0);
          closeModal();
        })
        .catch(() => {
          setKeepAliveFailCount((prev) => prev + 1);
        });
    }
    let keepAliveIntervalId: NodeJS.Timeout;

    if (personId) {
      callKeepAlive();
      keepAliveIntervalId = setInterval(() => callKeepAlive(), INTERVAL_TIME);
    }

    return () => {
      clearInterval(keepAliveIntervalId);
    };
  }, [personId, environment, loginUuid, closeModal]);

  return null;
};
